import React from 'react';
import ReactDOM from 'react-dom';
import Main from './Pages/Main'

ReactDOM.render(<Main />, document.getElementById('root'));